import React, { useContext } from "react";

import { Headline } from "../../Headline";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";
import t from "../../../lib/translate";

import * as styles from "./component.module.less";
import GeneralPageContext from "../../../templates/GeneralPageContext";
// import  "../../Button/component.module.less"

export function FormAside() {
    const { contactPerson, department } = useContext(GeneralPageContext);

    return (
        <aside className={styles.asideContentWrapper}>
            <div className={styles.asideContent}>
                <div className={styles.asideContactTextBlock}>
                    <Headline semanticOfHeadline="H5">
                        {department?.name}
                    </Headline>

                    {/*Added Static data for styling, Needs to be dynamic*/}
                    <div className={styles.asideContact}>
                        <p>{department?.subtitle}</p>
                        <p>{`${department.street} ${department.number}`}</p>
                        <p>{`${department.zip} ${department.place}`}</p>
                        <p className="textCap">{department.country}</p>
                    </div>
                </div>
                <div className={styles.asideContactDetailsBlock}>
                    {contactPerson?.phone && (
                        <a
                            href={`tel:${contactPerson.phone}`}
                            className={styles.asideContactDetails}
                        >
                            <span
                                className={gcs(
                                    "phone",
                                    "icon",
                                    styles.asideIcon
                                )}
                            ></span>
                            <span
                                className={gcs(
                                    styles.asideIconText,
                                    "icon-text"
                                )}
                            >
                                {contactPerson.phone}
                            </span>
                        </a>
                    )}

                    {contactPerson?.fax && (
                        <a
                            href={`fax:${contactPerson.fax}`}
                            className={styles.asideContactDetails}
                        >
                            <span
                                className={gcs(
                                    "printer",
                                    "icon",
                                    styles.asideIcon
                                )}
                            ></span>
                            <span
                                className={gcs(
                                    styles.asideIconText,
                                    "icon-text"
                                )}
                            >
                                {contactPerson.fax}
                            </span>
                        </a>
                    )}

                    {contactPerson?.email && (
                        <a
                            href={`mailto:${contactPerson.email.replace(
                                "[at]",
                                "@"
                            )}`}
                            className={styles.asideContactDetails}
                        >
                            <span
                                className={gcs(
                                    "mail",
                                    "icon",
                                    styles.asideIcon
                                )}
                            ></span>
                            <span
                                className={gcs(
                                    styles.asideIconText,
                                    "icon-text"
                                )}
                            >
                                {contactPerson.email}
                            </span>
                        </a>
                    )}
                </div>
            </div>
        </aside>
    );
}
